module.exports = __webpack_public_path__ + "static/thumb_patho-bcc64679291b5f27f9a0f30207e68e42.jpg";